// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){


	if(!(window.ActiveXObject) && "ActiveXObject" in window) {

		/*is explorer*/
		function msieversion() {
			let ua = window.navigator.userAgent;
			let msie = ua.indexOf("MSIE ");
			if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
			{
				const image_fit = document.getElementsByClassName('image-fit__wrapper');
				for(let i = 0; i < image_fit.length; i++ ){
					const this_image = image_fit[i].getElementsByTagName('img')[0];
					const image_data = this_image.dataset.srcset;
					const image_src = this_image.getAttribute('src');
					image_fit[i].classList.add('ie-bg');
					if(image_data){
						image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
					}else{
						image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
					}

				}
			}
			else
			{
				console.log('other browser');
			}
			return false;
		}
		msieversion();

	} else {
		/*****************************************************
		 OBSERVER TO ADD PARALLAX EFFECT
		 *****************************************************/
		let scrollParallax = []
		let scrolled = 0

		/* screen height */
		let v_height = window.innerHeight
			|| document.documentElement.clientHeight
			|| document.body.clientHeight;

		function doParallax(elm) {

			let boundes = elm.dataset.parallax.split(",") /* get it from html */
			/*get distance in positive value*/
			let distance = Math.abs(boundes[0] - boundes[1])
			if (boundes[0] > boundes[1]) {
				/*get distance in negative value (to do the scroll inverse)*/
				distance = distance * -1
			}
			/*Equivalent distance using screen height + element height*/
			const unit_scroll = distance / (v_height + elm.offsetHeight)
			let temp = 0

			let topElement = 0;
			let element = elm;

			let id_elem = elm.dataset.parallaxid

			do {
				topElement += element.offsetTop || 0;
				element = element.offsetParent;
			} while (element)

			let parallaxFunction = function () {
				/*Obtain the distance between top screen and document top 0*/
				scrolled = document.documentElement.scrollTop || window.pageYOffset
				/*Distance of bottom page to top of the element*/
				let relative_distance = scrolled + v_height - topElement
				/*transpoling data to move the parallax element relative to the scroll of all the screen*/
				temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
				/*console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)*/
				elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
			}

			scrollParallax[id_elem] = parallaxFunction

			window.addEventListener('scroll', scrollParallax[id_elem])

		}

		let observers_parallax = document.querySelectorAll(".js-parallax-element")

		if (observers_parallax) {
			let options_parallax = {
				root: null, /* relative to document viewport */
				rootMargin: '0px', /* margin around root. Values are similar to css property. Unitless values not allowed */
				threshold: 0 /* visible amount of item shown in relation to root */
			}

			function handler_parallax(entries, observer) {
				let entry;
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						doParallax(entry.target)
					} else {
						let id_elem = entry.target.dataset.parallaxid
						window.removeEventListener('scroll', scrollParallax[id_elem])
					}
				})
			}

			let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
			let counter = 1
			observers_parallax.forEach(function (element) {
				observable_parallax.observe(element)
				element.dataset.parallaxid = counter
				counter++
			})
		}
		/********************************************************************************
		 END OF OBSERVER TO ADD PARALLAX EFFECT
		 ***********************************************************************************/
	}

	/* Text and Form Animations */
	let formModule = document.querySelectorAll('.form-module-wrapper form');
	let textModule = document.querySelectorAll('.text-modules-wrapper .text-modules');
	if(formModule){
		formModule.forEach(function(form_module) {
			form_module.classList.add('animate-fade', 'top');
		});
	}
	if(textModule){
		textModule.forEach(function(text_module) {
			text_module.classList.add('animate-fade', 'top');
		});
	}

	/* Remove empty <p> tags created by tinymce */
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//// Forms animation for labels   ----------------------------------------------------------------
	if (document.getElementById('email-signup_email_address')) {
		document.getElementById('email-signup_email_address').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_LNAME')) {
		document.getElementById('email-signup_LNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_FNAME')) {
		document.getElementById('email-signup_FNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	//CMS forms label animation ----------------------------------------------------------------
	if (document.getElementsByClassName('form-module__field').length > 0) {
		const MODULE_FIELDS = document.querySelectorAll('.form-module__field');
		MODULE_FIELDS.forEach((field) => {
			if (field.getElementsByTagName('input').length > 0) {
				if (field.getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && field.getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					field.getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					});
				}
			}
			if (field.getElementsByTagName('select').length > 0) {
				field.getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
			if (field.getElementsByTagName('textarea').length > 0) {
				field.getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
		});
	}

	document.addEventListener('DOMContentLoaded', () => {

		// ---------------------------------------------------------------- GENERAL SITE'S FUNCTIONS ----------------------------------------------------------------
		
		let galleryContainer = document.querySelector('#gallery-flex #content');

		if(galleryContainer){
			setTimeout(() => {
				galleryContainer.style.opacity = 1;
			}, 500);
		}

		if(document.getElementById('header').classList.contains('no-hero')){
			document.getElementById('header').classList.add('scroll');
		} else{
			scrollW();
			window.addEventListener('scroll', function(){
				scrollW();
			})
		}

		// Main Nav Dropdown
		let primaryNav = document.getElementById('primary-nav');
		if(primaryNav){
			primaryNav.querySelectorAll('li').forEach(function(primary_nav) {
				primary_nav.addEventListener("mouseover", (event) => {
					primary_nav.classList.add('hover');
					if(primary_nav.querySelector('ul.submenu')){
						primary_nav.querySelector('ul.submenu').classList.add('open');
					}
				});
				primary_nav.addEventListener("mouseout", (event) => {
					primary_nav.classList.remove('hover');
					if(primary_nav.querySelector('ul.submenu')){
						primary_nav.querySelector('ul.submenu').classList.remove('open');
					}
				});
			});

			// Parent <a> should be active if any submenu link is active
		function syncParentAnchors(primaryNav) {
			var submenus = primaryNav.querySelectorAll('ul.submenu');
			for (var i = 0; i < submenus.length; i++) {
				var ul = submenus[i];
				var activeChild = ul.querySelector('li > a.active');
				if (activeChild) {
				var parentLi = ul.parentNode;     
				if (parentLi) {
					var parentA = parentLi.getElementsByTagName('a')[0]; 
					if (parentA && !parentA.classList.contains('active')) {
					parentA.classList.add('active');
					}
				}
				}
			}
		}

		syncParentAnchors(primaryNav);
			var childLinks = primaryNav.querySelectorAll('ul.submenu li > a');
			for (var j = 0; j < childLinks.length; j++) {
				childLinks[j].addEventListener('click', function () {
				var li = this.parentNode;
				var ul = li ? li.parentNode : null;
				var parentLi = ul ? ul.parentNode : null;  
				if (parentLi) {
					var parentA = parentLi.getElementsByTagName('a')[0];
					if (parentA) parentA.classList.add('active');
				}
				});
			}
		}

		let secondaryNav = document.getElementById('secondary-header-ul_nav');
		if(secondaryNav){
			secondaryNav.querySelectorAll('li').forEach(function(secondary_nav) {
				secondary_nav.addEventListener("mouseover", (event) => {
					secondary_nav.classList.add('hover');
					if(secondary_nav.querySelector('ul.submenu')){
						secondary_nav.querySelector('ul.submenu').classList.add('open');
					}
				});
				secondary_nav.addEventListener("mouseout", (event) => {
					secondary_nav.classList.remove('hover');
					if(secondary_nav.querySelector('ul.submenu')){
						secondary_nav.querySelector('ul.submenu').classList.remove('open');
					}
				});
			});
		}

		/* Lightbox Gallerys */
		const customLightbox = new LBX('.js-lbx-gallery', {
			customClass:'lbx-gallery',
		});

		// BURGUER MENU DESKTOP ----------------------------------------------------------------

		const menuBtn = document.getElementById('menu-btn');
		const navigation = document.querySelector('.navigation');
		const closeMenuBtn = document.querySelector('.js-close-menu');

		menuBtn.addEventListener('click', function(event) {
			event.preventDefault();
			navigation.classList.add('open');
		});

		closeMenuBtn.addEventListener('click', function(event) {
			event.preventDefault();
			navigation.classList.remove('open');
		});

		var menu = document.querySelector("#privary-navigation");
		var slides = document.querySelectorAll(".menu-hover .slide");
	
		if (!menu || slides.length === 0) return; 
	
		slides[0].classList.add("active");
	
		var activeLink = menu.querySelector("a.active");
		if (activeLink) {
			var activeItem = Array.from(menu.children).indexOf(activeLink.closest(".privary-navigation__item"));
			slides.forEach(slide => slide.classList.remove("active")); 
			if (slides[activeItem]) {
				slides[activeItem].classList.add("active");
			}
		}
	
		menu.querySelectorAll("a").forEach(function (link) {
			link.addEventListener("mouseenter", function () {
				var parentItem = this.closest(".privary-navigation__item"); 
				if (!parentItem || !menu.contains(parentItem)) return;
	
				var hoverIndex = Array.from(menu.children).indexOf(parentItem);
				if (hoverIndex === -1) return; 
	
				slides.forEach(slide => slide.classList.remove("active"));
	
				if (slides[hoverIndex]) {
					slides[hoverIndex].classList.add("active");
				}
			});
		});


		// BURGUER MENU MOBILE ----------------------------------------------------------------

		const burgerMenuBtn = document.querySelector("#js-burgerMenuBtn");
		const burgerMenuContainer = document.querySelector("#js-menuContainer")
		const closeMenu = document.querySelector(".js-burger-close");
		
		//Open Menu

		if(burgerMenuBtn){
			burgerMenuBtn.addEventListener('click', function (e) {
				e.preventDefault();
				burgerMenuContainer.classList.add("open");
				document.body.classList.add("no-scroll");
			});
		}
		
		if(closeMenu){
			closeMenu.addEventListener('click', () => {
				burgerMenuContainer.classList.remove("open");
				document.body.classList.remove("no-scroll");
			});
		}

		// SHOW SUBMENU FUNCTION: 

		const submenuToShow = (linksSelector, linkSubmenu) => {
			let navLinks = document.querySelectorAll(linksSelector); 
			let submenu_active = document.querySelectorAll(linkSubmenu); 

			navLinks.forEach(link => {
				const parent = link.parentNode;
				let submenu = parent.querySelector('.submenu');
				link.addEventListener('click', (e) => {
					document.querySelectorAll('.submenu.active').forEach(activeSubmenu => {
						activeSubmenu.classList.remove('active');
					});
					document.querySelectorAll(`${linksSelector}.active`).forEach(activeLink => {
						activeLink.classList.remove('active');
					});
					link.classList.toggle('active');
					submenu.classList.toggle('active');
				});
			});
			submenu_active.forEach(sub => {
				if (sub.classList.contains('active')) {
					if (window.screen.width > 640) {
						let selectedLink = sub.parentNode.parentNode.parentNode.children[0];
						selectedLink.classList.add('selected');
					}else{
						let selectedLink = sub.parentNode.parentNode.parentNode.parentNode.children[0];
						selectedLink.classList.add('selected');
					}
				}

			})
		}

		if (window.screen.width > 640) {
			submenuToShow('#primary-nav li a', '.submenu li a');
		} else {
			submenuToShow('.mobileMenu__nav li a', '.sub-sub-menu .submenu li a');
		}


		const navItems = document.querySelectorAll('.privary-navigation__item');
		const navItemsMob = document.querySelectorAll('.mobileMenu__nav li');
		
		function addNoSubmenuClass() {
			navItems.forEach(item => {
				
				const submenu = item.querySelector('.privary-navigation__submenu');
				if (!submenu) {
					item.classList.add('no-submenu');
				}
			});
		}
		
		function addNoSubmenuMobileClass() {
			navItemsMob.forEach(item => {
				
				const submenu = item.querySelector('.sub-sub-menu');

				
				if (!submenu) {
					item.classList.add('no-submenu');
				}
			});

		}
		if(window.screen.width > 768) {
			addNoSubmenuClass();
		}else{
			addNoSubmenuMobileClass()
		}

	// background tags functionality 

	var mobile_device = window.matchMedia('(max-width: 640px)');
    var sections = document.querySelectorAll('.background-tags');

    sections.forEach(setupSection);

    if (mobile_device.addEventListener) {
      mobile_device.addEventListener('change', function () {
        sections.forEach(syncInitialState);
      });
    } 

    function setupSection(section) {
      section.dataset.mode = mobile_device.matches ? 'mobile' : 'desktop';

      section.addEventListener('click', function (e) {
        var mode = mobile_device.matches ? 'mobile' : 'desktop';

        // ----- MOBILE accordion mode -----
        if (mode === 'mobile') {
          var title = e.target.closest('.js-swiper-title');
          if (!title || !section.contains(title)) return;

          var item = title.closest('.js-swiper-item');
          if (!item) return;

          toggleMobileItem(section, item);
          return;
        }

        // ----- DESKTOP tabs with fade cards -----
        if (mode === 'desktop') {
		var tab = e.target.closest('.js-tab-tabs');
		if (!tab || !section.contains(tab)) return;

		if (tab.classList.contains('active')) return;

		var tag = tab.getAttribute('data-tag');
		if (!tag) return;

		var tabs = section.querySelectorAll('.js-tab-tabs');

		var oldActiveItem = section.querySelector('.js-tab-item.active');

		tabs.forEach(function (t) { t.classList.remove('active'); });
		tab.classList.add('active');

		var safeTag = (window.CSS && CSS.escape) ? CSS.escape(tag) : tag;
		var newItem = section.querySelector('.js-tab-item[data-tag="' + safeTag + '"]');

		if (oldActiveItem && oldActiveItem !== newItem) {
			oldActiveItem.classList.add('fade-out');
			oldActiveItem.addEventListener('animationend', function () {
			oldActiveItem.classList.remove('active', 'fade-out');
			}, { once: true });
		}

		if (newItem) {
			newItem.classList.add('active', 'fade-in');
			newItem.addEventListener('animationend', function () {
			newItem.classList.remove('fade-in');
			}, { once: true });
		}
		}


      });

      syncInitialState(section);
    }

    function syncInitialState(section) {
      var isMobile = mobile_device.matches;
      section.dataset.mode = isMobile ? 'mobile' : 'desktop';

      if (isMobile) {
        var items = section.querySelectorAll('.js-swiper-item');
        var copies = section.querySelectorAll('.js-swiper-copy');
        var hero = section.querySelector('.js-mobile-hero');

        items.forEach(function (i) { i.classList.remove('open'); });
        copies.forEach(function (c) { if (c) c.style.height = '0px'; });

        if (items.length) {
          var first = items[0];
          first.classList.add('open');

          var firstCopy = first.querySelector('.js-swiper-copy');
          var wrap = first.querySelector('.wrap');
          if (firstCopy && wrap) {
            firstCopy.style.height = wrap.clientHeight + 'px';
          }

          if (hero) {
            var src = first.dataset.img || '';
            var alt = first.dataset.imgAlt || '';
            if (src) {
              hero.src = src;
              hero.alt = alt;
            }
          }
        }
      } else {
        var copies2 = section.querySelectorAll('.js-swiper-copy');
        copies2.forEach(function (c) { if (c) c.style.height = ''; });

        var tabs = section.querySelectorAll('.js-tab-tabs');
        var items2 = section.querySelectorAll('.js-tab-item');

        tabs.forEach(function (t) { t.classList.remove('active'); });
        items2.forEach(function (i) { i.classList.remove('active'); });

        if (tabs.length)  tabs[0].classList.add('active');
        if (items2.length) items2[0].classList.add('active');
      }
    }

    function toggleMobileItem(section, itemToOpen) {
      var items = section.querySelectorAll('.js-swiper-item');
      var copies = section.querySelectorAll('.js-swiper-copy');
      var hero = section.querySelector('.js-mobile-hero');

      items.forEach(function (i) { i.classList.remove('open'); });
      copies.forEach(function (c) { if (c) c.style.height = '0px'; });

      itemToOpen.classList.add('open');

      var copy = itemToOpen.querySelector('.js-swiper-copy');
      var wrap = itemToOpen.querySelector('.wrap');
      if (copy && wrap) {
        copy.style.height = wrap.clientHeight + 'px';
      }

      if (hero) {
        var src = itemToOpen.dataset.img || '';
        var alt = itemToOpen.dataset.imgAlt || '';
        if (src) {
          hero.src = src;
          hero.alt = alt;
        }
      }
    }

	});

	animateto();
	
	// ---------------------------------------------------------------- INDIVIDUAL SITE'S FUNCTIONS ----------------------------------------------------------------

	// FIXED SUBMENU ************************************
	
	function isMobile() {
		return window.innerWidth <= 640;
	}
	
	function convertSubmenuToSelect() {
		const submenu = document.querySelector('.sub-menu__hold .sub-menu ul');
		if (!submenu) return;
	
		const select = document.createElement('select');
		select.setAttribute('aria-label', 'Section Navigation');
	
		submenu.querySelectorAll('li').forEach((li) => {
		const link = li.querySelector('a');
		const option = document.createElement('option');
		option.value = link.href;
		option.textContent = link.textContent.trim();
	
		if (link.classList.contains('active')) {
			option.selected = true;
		}
		
		select.appendChild(option);
		});
	
		select.addEventListener('change', (event) => {
		const selectedUrl = event.target.value;
		if (selectedUrl) {
			window.location.href = selectedUrl;
		}
		});
	
		submenu.parentNode.replaceChild(select, submenu);
	}
	
	if (isMobile()) {
		convertSubmenuToSelect();
	}

	const introContent = document.querySelector('#intro-content');
    if(introContent){
		if (introContent && introContent.querySelector('.sub-menu__hold .sub-menu')) {
			introContent.classList.add('with-submenu');
		} else {
			introContent.classList.remove('with-submenu'); 
		}
	}

	function toggleFixedSubmenuOnScroll() {
		const header = document.getElementById('header');
		const subMenuHold = document.querySelector('.sub-menu__hold');
	
		if (!header || !subMenuHold) return; 
		const initialSubMenuHoldTop = subMenuHold.getBoundingClientRect().top + window.scrollY;
	
		window.addEventListener('scroll', () => {
			const headerBottom = header.getBoundingClientRect().bottom + window.scrollY;
			if (headerBottom >= initialSubMenuHoldTop) {
			subMenuHold.style.position = 'fixed';
			subMenuHold.style.top = '80px';
			subMenuHold.classList.add('submenu-scroll');
			} else if (window.scrollY < initialSubMenuHoldTop) {
			subMenuHold.style.position = 'absolute';
			subMenuHold.style.top = '0px';
			subMenuHold.classList.remove('submenu-scroll');
			}
		});
	}
	
	toggleFixedSubmenuOnScroll();

})();

function animateto() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const targetId = this.getAttribute('href').substring(1);
            if (targetId && document.getElementById(targetId)) {
                scrollToTarget(targetId);
            }
        });
    });

    if (location.hash) {
        const targetId = location.hash.substring(1);
        if (document.getElementById(targetId)) {
            setTimeout(() => scrollToTarget(targetId), 100); 
        }
    }

    function scrollToTarget(target) {
        var gotoTarget = offset(document.getElementById(target)).top - 230;
        var from = window.pageYOffset;
        var to = gotoTarget;
        var duration = 1300;
        var start = new Date().getTime();

        var timer = setInterval(function () {
            var time = new Date().getTime() - start;
            var y = (from <= to)
                ? easeInOutQuart(time, from, to - from, duration)
                : easeInOutQuart(time, from, -(from - to), duration);

            window.scrollTo(0, y);
            if (time >= duration) clearInterval(timer);
        }, 1000 / 60);
    }
}

/* Ease Movement */
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
/* ScrollW */
function scrollW(){
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		// downscroll code
		if(!document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.add('scroll');
			document.getElementById('top-content').classList.add('scroll');
		}
	} else {
		if(document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.remove('scroll');
			document.getElementById('top-content').classList.remove('scroll');
		}
	}
	
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}



